import type { ReactNode } from 'react';

import { useMediaQuery } from 'react-responsive';

export function ResponsiveLayout({
  desktop,
  mobile,
}: {
  desktop: ReactNode;
  mobile: ReactNode;
}) {
  /**
   * @see https://gs.statcounter.com/screen-resolution-stats/desktop/worldwide
   */
  const isDesktop = useMediaQuery({
    minWidth: 1280,
  });
  return isDesktop ? desktop : mobile;
}
